import { Link } from 'react-router';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import mainMenus from '../assets/main-menu.json';

interface Props {
    lang: MultiLang;
}

const MainMenu = (props: Props) => {
    const { lang } = props;
    const links = mainMenus.map((item, idx) => {
        const title = Functions.mlang(item.title, lang);
        const style = idx === 0 ? 'menuTop' : 'menuMain';
        return (
            <li key={item.link}>
                <Link className={style} to={item.link}>
                    {title}
                </Link>
            </li>
        );
    });
    return <ul className="mainmenu">{links}</ul>;
};

export default MainMenu;
